'use client';

import { useFireflyRemoveBackgroundAction } from '@frameio/firefly-actions';

export function useRemoveBackgroundAction() {
  return useFireflyRemoveBackgroundAction();
}
